import tool01 from "../img/DeveloperTools/tool/Notion-logo.png";
import tool02 from "../img/DeveloperTools/tool/git.png";
import tool03 from "../img/DeveloperTools/tool/Visual_Studio_Icon_2019.png";
import tool04 from "../img/DeveloperTools/tool/Android.jpg";
import tool05 from "../img/DeveloperTools/tool/mantis-logo.jpg";
import tool06 from "../img/DeveloperTools/tool/Jenkins-logo.png";

const AppTools = {
    tools:[{src:tool01,text:"Notion"},{src:tool02,text:"Git"},{src:tool03,text:"Visual Studio"},{src:tool04,text:"Android Studio"},{src:tool05,text:"Mantis"},{src:tool06,text:"Jenkis"}],
    howToUse:[{headerText:"持續性整合(CI)",bodyText:`每天我們會多次將所有開發人員的工作副本合併到共享主線以避免日後在項目中出現程式整合的問題。它減少了項目後端的延遲。 此外，它也是保證良好輸出品質的重要工具。`,backgroundColor:"#E7F4FF"},
    {headerText:"敏捷開發agile",bodyText:`我們持續地對員工進行Scrum開發方法的培訓。要求開發人員取得Microsoft 開發方案認證`,backgroundColor:"#F5FCFC"},
    {headerText:"DevOps文化",bodyText:`團隊秉持著 DevOps 的軟體開發流程精神\n『在開發時期，就摻入了維護思維，在維護階段去想開發者角度』`,backgroundColor:"#F8F9F9"}]
}

export default AppTools;